// extracted by mini-css-extract-plugin
export var createNew = "styles-module__createNew___ADwSC";
export var createNewList = "styles-module__createNewList___H2Xlg";
export var input = "styles-module__input___FPV5E";
export var btns = "styles-module__btns___xKMMm";
export var btn = "styles-module__btn___p12ph";